import { Center } from '@chakra-ui/react';
import EventCalendarCarousel from 'presentation/components/modules/events/calendar/EventCalendarCarousel';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import { useFetchEventsScheduleQuery } from 'rtkQuery/sharespro/queries/events';

interface Props {
  containerWidth?: number;
  scrollBy?: number;
}

const EventCalendarCarouselContainer: FC<Props> = ({
  containerWidth,
  scrollBy,
}) => {
  const navigate = useNavigate();

  const { data } = useFetchEventsScheduleQuery();

  return (
    <Center>
      <EventCalendarCarousel
        events={data?.items ?? []}
        onEventClick={(eventId) => {
          navigate(AppRoute.eventDetail(eventId));
        }}
        containerWidth={containerWidth}
        scrollBy={scrollBy}
      />
    </Center>
  );
};

export default EventCalendarCarouselContainer;
